export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6C2 4.34315 3.34315 3 5 3H12C13.6569 3 15 4.34315 15 6V8C15 9.65685 13.6569 11 12 11H5C3.34315 11 2 9.65685 2 8V6ZM5 5C4.44772 5 4 5.44772 4 6V8C4 8.55228 4.44772 9 5 9H12C12.5523 9 13 8.55228 13 8V6C13 5.44772 12.5523 5 12 5H5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 15C2 13.3431 3.34315 12 5 12H19C20.6569 12 22 13.3431 22 15V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V15ZM5 14C4.44772 14 4 14.4477 4 15V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V15C20 14.4477 19.5523 14 19 14H5Z"
      fill="currentColor"
    />
  </svg>
);
